import Experiments from '@wix/wix-experiments';
import { withExperiments as withWixExperiments } from '@wix/wix-experiments-react';
import { compose } from 'recompose';

interface IWithExperiments {
  experiments: Experiments;
}

export const withExperiments = compose<IWithExperiments, any>(withWixExperiments);
